import { AtlasOptions, AtlasValues } from 'atlas-ds';
import { Entreprise } from 'services/model';

interface CompaniesListProps {
    onSelect: (entreprise: Entreprise) => void
    entreprises: Entreprise[];
}

export default function CompaniesList(props: CompaniesListProps) {
    return <AtlasOptions
        ariaLabel="Sélection de l'entreprise"
        options={props.entreprises.map(entreprise => ({
            id: entreprise.id,
            onSelect: () => props.onSelect(entreprise),
            content: <AtlasValues label={ entreprise.name }>
                <AtlasValues>
                    <AtlasValues.Value label="SIREN">
                        { entreprise.siren ? entreprise.siren : entreprise.siret?.substring(0, 9) }
                    </AtlasValues.Value>
                    { entreprise.branche && <AtlasValues.Value label="Branche">
                        { entreprise.branche.label }
                    </AtlasValues.Value> }
                    { entreprise.adresse && <AtlasValues.Value full label="Adresse">
                        { entreprise.adresse.trim() }
                    </AtlasValues.Value> }
                </AtlasValues>
            </AtlasValues>
        })) || []}
    />
}
